import React from 'react';
import Flagship from '../../core/flagship';
import {connect} from 'react-redux';
import { Loader, Header, Grid, Modal, Button, Icon, Label } from 'semantic-ui-react';
import {empty, renderFieldValue} from '../../utils/helpers';

class LineItemViewModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.editName = this.editName.bind(this);
        this.duplicateLineItem = this.duplicateLineItem.bind(this);
    }

    getInitialState() {
        return {
            loading:true,
            id: this.props.lineItemId,
            line_item_key: '',
            line_item_name: '',
            line_item_type: '',
            parent_rfp: 0,
            vendor: '',
            cogs: '',
            price: '',
            lineItemData: [],
            errors: []
        };
    }

    componentDidMount() {
        // Get Form
        let self = this;
        Flagship.get(
            'line-item/read/' + self.props.lineItemId,
            {
                withData: true
            },
            function (response) {
                if (response.data.success === true) {

                    let data = response.data.data;
                    data.sort(function(a,b) {return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0);} );

                    self.setState(
                        response.data.result,
                        function() {
                            self.setState({
                                loading:false,
                                lineItemData:data
                            });
                    });


                } else {

                    Flagship.error(
                        "Error getting line item form from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting line item form from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }

    onChange(e, data, field) {

        let parentOnChange = this.props.onChange;

        let newState = Object.assign({}, this.state);

        newState[field] = data;

        this.setState(newState, function() {
            parentOnChange(this.state);
        });
    }

    editName() {
        this.setState({
            editingName: true
        });
    }

    duplicateLineItem() {

        let self = this;
        Flagship.post(
            "line-item/duplicate/" + self.state.id + '/' + this.state.parent_rfp,
            {},
            function(response) {
                if (response.data.success === true) {
                    Flagship.event("create-line-item", self.state.line_item_name, self.props.recordId, self.props.userId);
                    Flagship.notify("Line item duplicated.", "success");
                    self.props.cancelUpdate();
                    self.props.getLineItems();

                } else {
                    Flagship.error("Error duplicating line item.", self.props.recordId, self.props.userId);
                }
            }, function(err) {
                Flagship.error("Error duplicating line item: " + err, self.props.recordId, self.props.userId);
            }
        );
    }

    render() {

        if( this.state.loading === true ) {
            return (
                <Loader />
            );

        } else {

            return (
                <Modal
                    open={this.props.open}
                    onClose={this.props.cancelUpdate}
                    closeIcon
                >
                    <Button floated="right" className="view-edit-line-item" onClick={this.props.swapToEdit}>
                        <Icon name="edit"/>
                        Edit
                    </Button>
                    <Button floated="right" className="view-edit-line-item" onClick={this.duplicateLineItem}>
                        <Icon name="copy"/>
                        Duplicate
                    </Button>
                    <Header icon="pin" content={this.props.lineItem.line_item_key + ' - ' + this.props.lineItem.line_item_name}/>

                    <Modal.Content>
                        <div>
                            <Grid>
                                <Grid.Column width={16}>
                                    <Header as="h3">Line Item Info</Header>
                                    {!empty(this.state.lineItemData) ? this.state.lineItemData.map(function(item, i) {
                                        return (
                                            <div key={"line-item-pricing-form-field-" + i} className="flagship-single-field single-record-single-field">
                                                {!empty(item.label) ? <div><Label>{item.label}</Label> <br/></div> : null }
                                                <div className="field-value">

                                                    {renderFieldValue(item.field_value, item.validation)}
                                                </div>
                                            </div>
                                        );
                                    }) : <div>No line item data to display.</div> }
                                </Grid.Column>
                            </Grid>
                        </div>

                    </Modal.Content>
                </Modal>


            );

        }
    }
}

function mapStateToProps(state) {
    return {
        username: state.main.username,
        userId: state.main.userId,
        userRole: state.main.userRole
    };
}

export default connect(
    mapStateToProps,
    null
)(LineItemViewModal);


// WEBPACK FOOTER //
// ./src/components/modals/LineItemViewModal.js